
import React from 'react'

import { IGeneralData } from '@np/np_webcomponentlib'

import { optionEnum } from '../../shared/entityOperations/EntityFormTypes'

import { Column, ListFields } from '@np/np_webcomponentlib'

import { EntityFormProps } from '../../shared/entityOperations/EntityFormTypes'

import { ColumnWithCopyToClipboard } from '../../shared/entityOperations/EntityOperationsCustomFC'



import {EntityType as BusinessType} from '../Business/BusinessTypes'
import { typeOperationLabels } from '../../shared/MasterData/MasterDataTypes'


export interface EntityType {
  [key: string]: string | number | Date | boolean | BusinessType | null | undefined ; // Допускаем, что значения могут быть строками или числами
  idBusiness: string;  // UUID тип в TypeScript используется как string
  amount: number;
  basis: string;
  exchangeRate: number;
}

export enum TypeStatusEnum
{
  created,
  in_progress,
  success,
  failed
}




export interface optionEnumTypeStatusEnum {
  value?:TypeStatusEnum
  label:string
  isDisabled?:any
}



export const optionsEnumStatusDoc: optionEnumTypeStatusEnum[] = [
  { value: undefined, label: 'Choose one', isDisabled: "true" },
  { value: TypeStatusEnum.created, label: 'Создана' },
  { value: TypeStatusEnum.in_progress, label: 'В обработке' },
  { value: TypeStatusEnum.success, label: 'Успешно' },
  { value: TypeStatusEnum.failed, label: 'С ошибкой' },
];



export enum TypeCurrencyEnum
{
  NOTSET,
  RUB,
  USDT
}


export interface optionEnumTypeCurrencyEnum {
  value?:TypeCurrencyEnum
  label:string
  isDisabled?:any
}

export const optionsEnumTypeCurrency: optionEnumTypeCurrencyEnum[] = [
  { value: undefined, label: 'Choose one', isDisabled: "true" },
  { value: TypeCurrencyEnum.RUB, label: 'RUB' },
  { value: TypeCurrencyEnum.USDT, label: 'USDT' }
];

export interface DataEntityType extends IGeneralData, EntityType {
  businessAsProduct? : BusinessType;
  currency: TypeCurrencyEnum;
  status: TypeStatusEnum;
  amountInCurrencyBalance: number;
  typeOperation: TypeOperationEnum;
}

export interface DataEntityTypeViewModel {
  
}


//Расширенные данные для передачи сущности с предустановленными значениями для создания
export interface EntityFormPropsWithType extends EntityFormProps {
  initEntityProps: EntityType | undefined
}

// export const getEntityBylistVals = (listFields: ListFields[], entity: EntityType): EntityType => {
//   // Создаем новый объект на основе initEntity, чтобы не изменять оригинал
//   const updatedEntity: EntityType = { ...entity };

//   listFields.forEach(field => {
//     // Проверяем, существует ли такое поле в initEntity
//     if (field.fieldName in updatedEntity) {
//       // Устанавливаем первое значение из listVal, если оно существует
//       const valueToSet = field.listVal.length > 0 ? field.listVal[0] : '';
//       updatedEntity[field.fieldName] = valueToSet;
//     }
//   });

//   return updatedEntity;
// }


export const initEntity: EntityType = {
  idBusiness: "",
  amount: 0.00,
  basis: "",
  exchangeRate: 0.00,
}




export const columnsIdrfspecification: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },

  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 5,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]




export const columnsForChoise: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },


  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 6,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]



export const columnsIdrfcharacteristictype: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },


  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 6,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]




// Функция для форматирования даты
const formatDate = (dateString: string): string => {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  return `${day}.${month}.${year}`;
};

// Функция для форматирования времени
const formatTime = (timeString: string): string => {
  // Предполагаем, что timeString в формате "hhmm"
  const hours = timeString.substring(0, 2);
  const minutes = timeString.substring(2, 4);
  return `${hours}:${minutes}`;
};



interface PropsDisplayStatusDoc {
  statusDoc: string
}


export const DisplayStatusDoc: React.FC<PropsDisplayStatusDoc> = ({ statusDoc }) => {
  return (
    <div>
      {statusDoc === 'success' &&
        <button className="btn btn-success btn-sm" style={{ width: '100px' }}>Успешно</button>
      }

      {statusDoc === 'created' &&
        <button className="btn btn-secondary btn-sm" style={{ width: '100px' }}>Создан</button>
      }

      {statusDoc === 'in_progress' &&
        <button className="btn btn-primary btn-sm" style={{ width: '100px' }}>В обработке</button>
      }

      {statusDoc === 'failed' &&
        <button className="btn btn-danger btn-sm" style={{ width: '100px' }}>С ошибкой</button>
      }

    </div>
  );
};




export enum TypeOperationEnum {
  payIn = "payIn",
  payOut = "payOut",
  balanceReplenishment = "balanceReplenishment",
  balanceWithdrawal = "balanceWithdrawal",
  providerSettle = "providerSettle",
  providerVirtualSettle = "providerVirtualSettle",
  merchantSettle = "merchantSettle",
  merchantVirtualSettle = "merchantVirtualSettle"
}




export interface optionEnumTypeOperationEnum {
  value?:TypeOperationEnum
  label:string
  isDisabled?:any
}



export const optionsEnumTypeOperation: optionEnumTypeOperationEnum[] = [
  { value: undefined, label: 'Choose one', isDisabled: "true" },
  { value: TypeOperationEnum.payIn, label: 'Приход' },
  { value: TypeOperationEnum.payOut, label: 'Выплата' },
  { value: TypeOperationEnum.balanceReplenishment, label: 'Поступление на баланс' },
  { value: TypeOperationEnum.balanceWithdrawal, label: 'Списание с баланса' },

  { value: TypeOperationEnum.providerSettle, label: 'Сеттел провайдера' },
  { value: TypeOperationEnum.providerVirtualSettle, label: 'Вирт. сеттл провайдера' },
  { value: TypeOperationEnum.merchantSettle, label: 'Сеттел мерчанта' },
  { value: TypeOperationEnum.merchantVirtualSettle, label: 'Вирт сеттл мерчанта' },

];


interface PropsDisplayTypeOperation {
  typeOperationData: TypeOperationEnum
}

export const DisplayTypeOperation: React.FC<PropsDisplayTypeOperation> = ({ typeOperationData  }) => {
  return (
    <div>
      {typeOperationData === TypeOperationEnum.payIn &&
        <button className="btn btn-light btn-sm" style={{ width: '150px' }}>Приход</button>
      }

      {typeOperationData === TypeOperationEnum.payOut &&
        <button className="btn btn-light btn-sm" style={{ width: '150px' }}>Выплата</button>
      }

      {typeOperationData === TypeOperationEnum.balanceReplenishment &&
        <button className="btn btn-secondary btn-sm" style={{ width: '150px' }}>Поступление на баланс</button>
      }

      {typeOperationData === TypeOperationEnum.balanceWithdrawal &&
              <button className="btn btn-secondary btn-sm" style={{ width: '150px' }}>Списание с баланса</button>
            }

      {typeOperationData === TypeOperationEnum.providerSettle &&
              <button className="btn btn-secondary btn-sm" style={{ width: '150px' }}>Сеттел провайдера</button>
            }


      {typeOperationData === TypeOperationEnum.providerVirtualSettle &&
              <button className="btn btn-secondary btn-sm" style={{ width: '150px' }}>Вирт. сеттл провайдера</button>
            }

            {typeOperationData === TypeOperationEnum.merchantSettle &&
              <button className="btn btn-light btn-sm" style={{ width: '150px' }}>Сеттел мерчанта</button>
            }


      {typeOperationData === TypeOperationEnum.merchantVirtualSettle &&
              <button className="btn btn-secondary btn-sm" style={{ width: '150px' }}>Вирт сеттл мерчанта</button>
            }


    </div>
  );
};